import { render } from "./ChatWith.vue?vue&type=template&id=0cf5775c&scoped=true"
import script from "./ChatWith.vue?vue&type=script&lang=js"
export * from "./ChatWith.vue?vue&type=script&lang=js"

import "./ChatWith.vue?vue&type=style&index=0&id=0cf5775c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf5775c"]])

export default __exports__